<template>
  <div class="form">
    <div class="form__content">
      <IdentityQueueStepCounter />
      <h1 class="extra-large-headline">
        {{ $t("PageTitle.headline.purposeOfTransactionHeader") }}
      </h1>
      <p class="bodycopy">
        {{ $t("PageSubTitle.paragraph.purposeOfTransactionInstructions") }}
      </p>
    </div>
    <form @submit.prevent>
      <FormSelect
        name="potMainPurpose"
        type="text"
        iconType="QuestionMarkCircle"
        iconColor="#0072CA"
        :items="potMainPurposeAnswers"
        :label="$t('FormSelect.label.potMainPurpose')"
        @dropdownValueUpdate="updateDropdown"
      />

      <Checkbox
        name="tnc"
        :text="$t('Checkbox.text.purposeOfTransactionTnc')"
        v-model:value="form.tnc"
        v-model:tnc="form.tnc"
        :errors="store.getErrorByField('tnc')"
      />

      <ButtonBase
        :isDisabled="store.formHasErrors || globalStore.getIsFormLoading"
        :isLoading="globalStore.getIsFormLoading"
        @onButtonClick="handleFormSubmit"
      >
        {{ $t("ButtonBase.label.submitMyDetails") }}
      </ButtonBase>
      <IdentityQueueNext />
    </form>
  </div>
</template>

<script setup>
import { ref } from "vue";
import { useRoute, useRouter } from "vue-router";

import { useGlobalStore } from "@/stores/globalStore";
import { usePurposeOfTransactionStoreStore } from "@/stores/forms/purposeOfTransactionFormStore";
import { useIdentityQueueStore } from "@/stores/identityQueueStore";

import useApiHelpers from "@/composables/api/helpers";
import useWatchAndUpdate from "@/composables/helpers/useWatchAndUpdate";
import useCustomerActions from "@/composables/api/useCustomerActions";

import FormSelect from "@/components/ui/selects/FormSelect.vue";
import Checkbox from "@/components/ui/inputs/Checkbox.vue";
import ButtonBase from "@/components/ui/buttons/ButtonBase.vue";
import IdentityQueueStepCounter from "@/components/layout/progress/IdentityQueueStepCounter.vue";
import IdentityQueueNext from "@/components/layout/progress/IdentityQueueNext.vue";

const route = useRoute();
const router = useRouter();

const store = usePurposeOfTransactionStoreStore();
const identityQueueStore = useIdentityQueueStore();
const globalStore = useGlobalStore();
const { postRequest } = useApiHelpers();
const { watchAndUpdateStore } = useWatchAndUpdate();
const { fetchCustomerId } = useCustomerActions();

// todo mocked for now, to get from an endpoint
const potMainPurposeAnswers = [
  "Investment",
  "Trading",
  "Payment for online purchases",
  "Payment for services",
  "Gaming",
  "Ransomware / virus/ cyber extortion demands",
  "Other",
];

const form = ref({
  potMainPurpose: "",
  tnc: false,
});

const updateDropdown = (dropdownData) => {
  const field = Object.keys(dropdownData)[0];
  const value = Object.values(dropdownData)[0];
  form.value[field] = value;
};

const handleFormSubmit = async () => {
  const custId = await fetchCustomerId();

  const formData = {
    documentType: "purpose_of_transaction",
    documentReference: custId,
    declaredPurposeOfTransaction: [form.value.potMainPurpose],
  };

  globalStore.setIsFormLoading(true);
  postRequest("documents/edd", formData, () => {
    identityQueueStore.updateToNextRoute();
    identityQueueStore.fetchNextIdentityRoute(route).then((nextRoute) => {
      router.push(nextRoute);
    });
  });
};

watchAndUpdateStore(form, store, () => {});
</script>
